import I18n from 'i18n-js';
import React from 'react';
import classNames from 'classnames';

import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useURL } from '@reverbdotcom/commons/src/url_context';
import { inExperiment, useUser } from '@reverbdotcom/commons/src/user_hooks';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';

import { Paths } from '../../shared/url_helpers';
import { isEndedWatchesPath } from '../../shared/url_helpers';

export const ACTIVE_CLASS = 'feed-container__tab--active';

type IProps = IUserContext;

export function FeedTabs() {
  const url = useURL();
  const user = useUser();
  const watchlistClassName = classNames({ [ACTIVE_CLASS]: isEndedWatchesPath(url) });

  const recommendationsPath = () => {
    if (inExperiment(user, experiments.FAVORITES)) {
      return '/';
    }
    return Paths.myRecommendations.expand({});
  };

  return (
    <nav className="feed-container__tabs">
      <ul>
        <li className="feed-container__tab">
          <CoreLink to="/my/feed" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.feed')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/my/feed/customize" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.customize')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/watched_products" activeClassName={ACTIVE_CLASS} className={watchlistClassName}>
            {I18n.t('discovery.feed.tabs.watchList')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to="/browsing_history" activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.recentlyViewed')}
          </CoreLink>
        </li>
        <li className="feed-container__tab">
          <CoreLink to={recommendationsPath()} activeClassName={ACTIVE_CLASS}>
            {I18n.t('discovery.feed.tabs.recommended')}
          </CoreLink>
        </li>
      </ul>
    </nav>
  );
}

export default withUserContext<IProps>(FeedTabs);
